import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  tableCell: {
    padding: '0 !important',
  },
  mainRow: {
    display: 'flex',
    cursor: 'pointer',
    padding: '12px 8px',
    alignItems: 'center',
    fontSize: '14px',
    fontWeight: 600,
    color: theme.palette.grey[600],
    transition: 'all .3s ease-in-out',
    '&:hover': {
      backgroundColor: 'rgba(0,0,0,.01)',
    },
    '& small': {
      fontSize: '14px',
      fontWeight: 400,
      color: theme.palette.grey[400],
    },
    '& > div:first-of-type': {
      flexGrow: 1,
      display: 'flex',
      [theme.breakpoints.down('xs')]: {
        flexDirection: 'column',
      },
      '& > div': {
        padding: '0 8px',
        [theme.breakpoints.down('xs')]: {
          padding: '4px 0',
        },
      },
    },
  },
  collapse: {
    padding: '0 8px 12px',
    [theme.breakpoints.down('xs')]: {
      padding: 0,
    },
  },
  entries: {
    flexGrow: 1,
  },
  valueLabel: {
    paddingRight: '16px',
  },
}));
